export default "__VITE_ASSET__CqBxLaJC__"